<template>
  <div class="content">
    <div v-if="orderList.length && requestEnd">
      <div class="item" v-for="order in orderList" :key="order.id" @click="toOrderDetail(order)">
        <div class="item-con" style="border-bottom: 1px solid #EBEBEB">
          <span class="title">订单编号</span>
          <span class="id">{{order.order_no}}</span>
          <!-- <span class="right"><img :src="public_path + '/static/images/arrow_right.svg'" alt=""></span> -->
          <span class="right" :style="{color: order.state == 0 ? '#FD5A41' : order.state == 1 ? '#F58423' : order.state == 4 ? '#ADADAD' : '#F58423'}">{{order.state_cn}}</span>
        </div>
        <div class="item-con">
          <span :class="['type', order.type == 0 ? 'share' : 'sell']">{{order.type == 0 ? '租赁订单' : '购买订单'}}</span>
          <span class="sum">￥{{order.amount}}</span>
          <!-- <span class="status">{{order.state_cn}}</span> -->
          <span class="right"><img :src="public_path + '/static/images/arrow_right.svg'" alt=""></span>          
        </div>
        <div class="item-con" style="padding-top: 0; font-size: .26rem;">
          <span class="time">{{order.created_at}}</span>
        </div>
      </div>
    </div>
    <div v-if="!orderList.length && requestEnd" class="no-order">
      <img :src="public_path + '/static/images/no_order.png'" alt="">
      <p>暂无订单</p>
    </div>
  </div>
</template>
<script>
import { getEcmallOrders } from '@/http/api'
export default {
  data () {
    return {
      orderList: [],
      public_path: process.env.PUBLICK_PATH,
      requestEnd: false,
      channel_no: null
    }
  },
  methods: {
    toOrderDetail (order) {
      this.$router.push({
        name: 'Orderdetail',
        params: {
          order: JSON.stringify(order),
          id: order.order_no
        }
      })
    },
    getEcmallOrders () {
      console.log(this.channel_no)
      let channel_uid = ''
      if (this.channel_no == 'cjjlapp') {
        channel_uid = localStorage.cjjlapp_token
      } else if (this.channel_no == 'agent') {
        channel_uid = localStorage.token
      } else {
        channel_uid = localStorage.other_token
      }
      console.log('channel_uid=' + channel_uid)
      getEcmallOrders({channel_no: this.channel_no, channel_uid: channel_uid}).then(res => {
        console.log(res)
        if (res.code === 0) {
          this.orderList = res.data.total ? res.data.list : []
          console.log(this.orderList)
          this.requestEnd = true
        }
      })
    }
  },
  mounted () {
    this.channel_no = this.$route.query.channel_no ? this.$route.query.channel_no : localStorage.channel_no
    localStorage.setItem('channel_no', this.channel_no)
    this.getEcmallOrders()
  }
}
</script>
<style lang="scss" scoped>
.content {
  font-size: 0;
  color: #333;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #f5f5f5;
  overflow-y: auto;
  -webkit-overflow-scrolling:touch;
  .item {
    // padding: .4rem .3rem;
    background: #fff;
    margin-bottom: .2rem;
    // border-bottom: 1px solid #ebebeb;
    .item-con {
      display: -webkit-flex;
      padding: .26rem .3rem;
      align-items: center;
      font-size: .3rem;
      & + .item-con {
        padding: .3rem;
        // margin-top: .18rem;
      }
      .title {
        width: 1.7rem;
      }
      .id {
        flex: 2;
        color: rgba(51, 51, 51, .5);
      }
      .right {
        flex: 1;
        text-align: right;
        img {
          width: .14rem;
          height: .25rem;
          float: right;
        }
      }
      .sum {
        width: 1.7rem;
        font-size: .38rem;
        color: #000;
      }
      .status {
        line-height: .34rem;
        border-radius: .06rem;
        color: #999;
        font-size: .26rem;
        text-align: center;
      }
      .time {
        text-align: left;
        flex: 2;
        color: rgba(51, 51, 51, .5);
      }
      .type {
        padding: 2px 4px;
        color: #fff;
        margin-right: .4rem;
        font-size: .26rem;
        // width: 1.10rem;
        padding: 0 .14rem;
        height: .40rem;
        line-height: .4rem;
        border-radius: .16rem 0 .16rem 0;
        text-align: center;
      }
      .sell {
        background: #02B389;
      }
      .share {
        background: rgba(74,144,226,1);
      }
    }
  }
}
.no-order {
  img {
    width: 2.45rem;
    height: 1.64rem;
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2.62rem;
  }
  p {
    font-size: .28rem;
    color: rgba(51, 51, 51, 0.5);
    line-height: .40rem;
    margin-top: .8rem;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/Order_1.vue